import React, { useEffect, useState } from 'react';
import * as currency from '@shopify/theme-currency'
import { Product } from '../types/product'
import { Swiper, SwiperSlide } from "swiper/react";


export function ShuffleSlides2() {
  const variantItemsArr = ["5X5-HDCLW-STR-NTR-18","5X5-HDCLW-STR-613-LDARK-18", "5X5-HDCLW-STR-613-LLITE-18","5X5-HDCLW-STR-613-10","5X5-HDCLW-KSTR-NTR-14"];
  const variantImages=["https://wig-skus-v3.s3.amazonaws.com/5X5-HDCLW-STR-NTR-18-BANG.jpg", "https://wig-skus-v3.s3.amazonaws.com/5X5-HDCLW-STR-613-LDARK-18.jpg",
   "https://wig-skus-v3.s3.amazonaws.com/5X5-HDCLW-STR-613-LLITE-18.jpg", 
  "https://wig-skus-v3.s3.amazonaws.com/5X5-HDCLW-STR-613-10.jpg","https://wig-skus-v3.s3.amazonaws.com/5X5-HDCLW-KSTR-NTR-14.jpg"]
  const hrefs=[`/products/very-straight?variant=40222254432301&shade=ginger&cut=uncut&part_style=middle&prep=low bun&bang=yes&hair_styling=natural (un-styled)&adhesive=Adhesive`, 
  `/products/very-straight-blonde?variant=40467074252845&shade=ginger&cut=uncut&part_style=middle&prep=low bun&bang=no&hair_styling=natural (un-styled)&adhesive=Adhesive`,
  `/products/very-straight-blonde?variant=40467073990701&shade=ginger&cut=uncut&part_style=middle&prep=low bun&bang=no&hair_styling=natural (un-styled)&adhesive=Adhesive`,
  `/products/very-straight-blonde?variant=40738690301997&shade=ginger&cut=bob&part_style=middle&prep=low bun&bang=no&hair_styling=natural (un-styled)&adhesive=Adhesive`,
  `/products/kinky-straight?variant=40222251876397&shade=ginger&cut=uncut&part_style=middle&prep=low bun&bang=no&hair_styling=natural (un-styled)&adhesive=Adhesive`]
  const productsName=[`Very Straight w/ Bangs`, `Very Straight Dark Rooted Blonde`,'Very Straight Light Rooted Blonde','Very Straight Blonde Bob','Kinky Straight']
  const [productItemArr, setProductItemArr] = useState<string []>([])
  const selectors = {
    allProducts: '[data-all-products]',
  };
  const products: Product[] = JSON.parse(document.querySelector(selectors.allProducts).innerHTML);

  const hideArrowsOnMobileIfHeadingNotPresent = () => {
    const carouselContainer = document.querySelector(selectors.allProducts).parentElement;
    const title = carouselContainer.querySelector('h2');

    if (!title) {
      carouselContainer.querySelectorAll('button')
        .forEach((button) => {
          button.classList.add('hidden', 'lg:block');
        })
    }
  }

  useEffect(() => {
   
    const variantArr = products.flatMap((product: any) => product.variants);
    for (let i = 0; i <variantItemsArr.length; i++) {
      for(let j=0; i<variantArr.length; j++){
        if(variantItemsArr[i]===variantArr[j].sku){
         setProductItemArr (productItemArr => [...productItemArr, variantArr[j]] );
         break;
        }}}
    hideArrowsOnMobileIfHeadingNotPresent();
  }, [])

  useEffect(() => {
    const videos = document.querySelectorAll<HTMLElement>('[data-carousel-video]');

    videos.forEach((video: HTMLVideoElement) => {
      video.load();
    });

  },[variantImages])

  const swiperRef = React.useRef(null);

  return (

    <>
   
      <button className="absolute top-[15px] lg:top-[50%] -translate-y-2/4 left-4 lg:left-6" onClick={() => swiperRef.current.swiper.slidePrev()}>
        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.021 0.824463L1.52099 7.79848L9.02099 14.7725" stroke="black" stroke-width="2"/>
        </svg>
      </button>

      <button className="absolute top-[15px] lg:top-[50%] -translate-y-2/4 right-4 lg:right-6" onClick={() => swiperRef.current.swiper.slideNext()}>
        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.979004 15.2737L8.47901 8.29967L0.979006 1.32565" stroke="black" stroke-width="2"/>
        </svg>
      </button>

      <Swiper
        ref={swiperRef}
        slidesPerView={1}
        spaceBetween={15}
        initialSlide={1}
        loop={true}
        breakpoints={{
          1024: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
        }}
        className="swiper">
        {
          productItemArr.map((product, index) => {
            return <SwiperSlide className="!w-[54.933vw] lg:!w-[16.250vw] apex:!w-[234px]">
              <a className="block group hover:drop-shadow-card bg-white w-[54.933vw] lg:w-[16.250vw] apex:!w-[234px] border border-gray-400 hover:border-[#d2d2d2] transition-colors" href={hrefs[index]}>
                {/* <video className="w-[54.933vw] h-[52.267vw] lg:w-[16.250vw] lg:h-[16.875vw] apex:!w-[234px] apex:!h-[243px] object-cover" playsInline autoPlay loop muted data-carousel-video>
                    <source src={variantImages[index]} type="video/mp4" />
                  </video> */}
                      <img  src={variantImages[index]} className="w-[54.933vw] h-[52.267vw] lg:w-[16.250vw] lg:h-[16.875vw] apex:!w-[234px] apex:!h-[243px] object-cover" />
                    
                <div className="p-5 group-hover:opacity-100">
                  <div className="text-center">
                    <p className="text-sm lg:text-base">{productsName[index]}</p>
                    <p className="text-base lg:text-xl font-semibold mt-2">{currency.formatMoney(product.price, '${{amount_no_decimals}}')}</p>
                  </div>
                  <button className="font-semibold uppercase bg-black text-white block text-center text-sm leading-none p-2.5 mt-5 w-full">
                    tailor this wig
                  </button>
                </div>
              </a>
              </SwiperSlide>
          })
        }
      </Swiper>
    </>
  );
}
